import { UflrType } from 'lib/uflr';
import { IFolderFlags } from 'reactApp/modules/home/home.types';
import { WeblinkDownloadable } from 'reactApp/modules/public/public.types';
import { CloudItem, EStorageType } from 'reactApp/modules/storage/storage.types';
import { IPublicInfo, Kind, SubKind, Url, VirusScan } from 'reactApp/types/Tree';

export interface IAlbumsState {
    list: Record<string, AlbumItem>;

    currentUploadAlbum?: string;
}

export type AlbumItem = IAlbum | IAlbumItem;

export interface IAlbum extends Partial<IPublicInfo>, WeblinkDownloadable {
    id: string;
    name: string;
    storage: EStorageType.albums;
    isFolder: true;
    kind: Kind;
    cursor?: string;
    isLoading?: boolean;
    isLoaded?: boolean;
    hasMoreToLoad?: boolean;
    parent: string;
    flags?: IFolderFlags;
    type: 'album';
    childs: string[];

    thumbnails?: Record<string, string>;

    error?: boolean;
    isReadOnly?: boolean;
}

export interface IAlbumItem extends Partial<IPublicInfo>, WeblinkDownloadable {
    name: string;
    mtime: number;
    size: number;
    id: string;
    storage: EStorageType.albums;
    ext: string;
    nameWithoutExt: string;
    parent: string;
    virusScan: VirusScan;
    isFolder: false;
    thumbnails?: Record<string, string>;
    url?: Url;
    kind: Kind;
    subKind: SubKind;
    isInFavorites: boolean;
    uflr?: UflrType;
    path: string;
    home: string;
    type: 'album';
    isReadOnly?: boolean;
}

export interface ICreateAlbumSuccess {
    id: string;
    name: string;
}

export interface ICreateAlbumRequest {
    albumName?: string;
    items?: CloudItem[];
}

export const isAlbum = (album): album is IAlbum => (album ? (album as IAlbum)?.type === 'album' : false);

export interface IAlbumId {
    albumId: string;
}

export interface ILoadAlbumSuccess {
    albumId: string;
    cursor?: string;
    list: AlbumItem[];
    title: string;
}

export interface IAddItems {
    albumId: string;
    items: AlbumItem[];
}

export interface ILoadAlbumsListSuccess {
    cursor: string;
    list: IAlbum[];
}
